<div class="form-group">
  @if (showLabel && (question?.email_version || labelText)) {
    <label>
      {{question?.email_version ? question?.email_version : labelText}}
    </label>
  }



  @if (showNoteText) {
    <div class="notice notice--info mt-15 mb-15">
      <div class="notice__content">
        <svg class="icon">
          <use xlink:href="#info"></use>
        </svg>
        <p [innerHTML]="noteText"></p>
      </div>
    </div>
  }

  @if (showUploadLabelText) {
    <div class="custom-upload__label">
      <small [innerHTML]="uploadLabelText"></small>
    </div>
  }
  <div
    class="custom-upload dz-clickable"
    [id]="uniqueId"
    [ngClass]="uploaderType === QuestionTypes.upload_documents ? 'custom-upload--docs' : 'custom-upload--media'">
    <div class="custom-upload__dropzone dz-default">
      <div class="custom-upload__thumb">
        <img [src]="thumbPath" alt="">
      </div>
      <div class="custom-upload__instructions">
        <p>Tap to add files</p>
        <svg class="icon">
          <use xlink:href="#upload"></use>
        </svg>
        <p>Drag & drop files here or <strong>browse</strong>
      </p>
    </div>
  </div>
</div>
<a href="" id="fake"></a>
</div>
